<template>
	<Modal :value="value" @input="v => $emit('input', v)" :width="640" :middle="true" :hasCloseIcon="true">
		<div slot="header">凭证打印</div>
		<div class="print-opt">
			<div class="po-row">
				<label>打印方向</label>
				<Select v-model="dir" :datas="['纵向', '横向']" :disabled="false"></Select>
			</div>
			<div class="po-row">
				<label>打印纸张</label>
				<Select v-model="paper" :datas="['A4', 'A5']"></Select>
			</div>
			<div class="po-row">
				<label>版式选择</label>
				<Select v-model="layout" :datas="['一版', '两版', '三版']" :disabled="layoutDisabled"></Select>
			</div>
			<div class="po-row">
				<label>凭证行数</label>
				<Select v-model="lineNum" :datas="[5, 6, 7, 8]" :disabled="lineNumDisabled"></Select>
			</div>
			<div class="po-row">
				<label>对齐方式</label>
				<Select v-model="align" :datas="['靠上', '居中']" :disabled="alignDisabled"></Select>
			</div>
			<div class="po-row">
				<label>超长摘要</label>
				<Select v-model="textOverflow" :datas="['截断', '不截断']"></Select>
			</div>
			<div class="po-row">
				<label>字体大小</label>
				<Select v-model="fontSize" :datas="[8, 9, 10, 11, 12]"></Select>
			</div>
			<div class="po-row">
				<label>单元格间距</label>
				<NumberInput v-model="cellPadding" :min="0" :max="5" :step="0.2"></NumberInput>
			</div>
			<div class="po-row">
				<label>打印封面</label>
				<Checkbox v-model="withCover">同时打印封面</Checkbox>
			</div>
			<div class="po-row">
				<label>打印日期</label>
				<Checkbox v-model="showPrintDate">显示</Checkbox>
				<DatePicker v-model="printDate" format="YYYY-MM-DD" :disabled="!showPrintDate"></DatePicker>
			</div>
			<div class="po-row">
				<label>附件</label>
				<Checkbox v-model="withAttachments">打印附件</Checkbox>
			</div>
			<div class="po-signers">
				<div class="po-row"><label>主管</label><Input v-model="managerUser" placeholder="留空=无"/></div>
				<div class="po-row"><label>记账</label><Input v-model="bookkeeperUser" placeholder="留空=无"/></div>
				<div class="po-row"><label>审核</label><Input v-model="auditUser" placeholder="留空=默认审核人"/></div>
				<div class="po-row"><label>出纳</label><Input v-model="cashierUser" placeholder="留空=无"/></div>
			</div>
		</div>
		<div slot="footer" class="text-right">
			<Button @click="$emit('input', false)">取消</Button>
			<Button color="primary" @click="doPrint">打印</Button>
		</div>
	</Modal>
</template>

<script>
	import Qs from "qs";
	import moment from 'moment'

	export default {
		name: "VoucherPrintModal",
		props: {
			value: {type: Boolean, default: false},
			baseParams: {type: Object, default: () => ({})}
		},
		data() {
			return {
				dir: '纵向', paper: 'A4', layout: '两版', lineNum: 5,
				align: '靠上', textOverflow: '截断', fontSize: 10, cellPadding: 1,
				withCover: false, showPrintDate: false, printDate: moment().format('YYYY-MM-DD'),
				withAttachments: false, managerUser: '', bookkeeperUser: '', auditUser: '', cashierUser: ''
			};
		},
		computed: {
			layoutDisabled() {
				return this.paper === 'A5' || this.dir === '横向';
			},
			lineNumDisabled() {
				return this.layout === '三版' || (this.paper === 'A4' && this.layout === '一版');
			},
			alignDisabled() {
				return this.dir === '纵向' || this.paper === 'A5' || (this.paper === 'A4' && this.layout === '一版');
			}
		},
		watch: {
			paper(v) {
				if (v === 'A5') this.layout = '一版';
			},
			dir(v) {
				if (v === '横向') this.layout = '一版';
			},
			layout(v) {
				if (v === '三版') this.lineNum = 5;
			}
		},
		mounted() {
			try {
				const saved = localStorage.getItem('printOpt');
				if (saved) Object.assign(this, JSON.parse(saved));
				// 兼容旧版 localStorage（paperType/layout 命名）
				if (this.paperType) {
					if (this.paperType === 'A4两版') { this.paper = 'A4'; this.layout = '两版'; }
					else if (this.paperType === 'A4三版') { this.paper = 'A4'; this.layout = '三版'; }
					else if (this.paperType === 'A4' || this.paperType === 'A5') { this.paper = this.paperType; }
				}
			} catch (e) {
			}
		},
		methods: {
			doPrint() {
				const opts = {
					dir: this.dir, paper: this.paper, layout: this.layout, lineNum: this.lineNum,
					align: this.align, textOverflow: this.textOverflow, fontSize: this.fontSize,
					cellPadding: this.cellPadding,
					withCover: this.withCover ? true : false,
					showPrintDate: this.showPrintDate ? true : false,
					printDate: this.showPrintDate ? moment(this.printDate).format('YYYY-MM-DD') : '',
					withAttachments: this.withAttachments ? true : false,
					managerUser: this.managerUser || '', bookkeeperUser: this.bookkeeperUser || '',
					auditUser: this.auditUser || '', cashierUser: this.cashierUser || ''
				};
				try {
					localStorage.setItem('printOpt', JSON.stringify(opts));
				} catch (e) {
				}
				const params = Object.assign({}, this.baseParams, opts);
				const qs = Qs.stringify(params, {indices: false});
				window.open(`/api/pfd/voucher?${qs}`);
				this.$emit('input', false);
			}
		}
	};
</script>

<style lang="less" scoped>
	.print-opt {
		display: flex;
		flex-wrap: wrap;
		padding: 4px 8px;

		.po-row {
			width: 50%;
			display: flex;
			align-items: center;
			margin: 6px 0;

			> label {
				width: 84px;
				flex: none;
				color: @dark2-color;
			}

			/deep/ .h-input, /deep/ .h-select, /deep/ .h-numberinput {
				width: 160px;
			}
		}

		.po-signers {
			width: 100%;
			border-top: 1px dashed @gray2-color;
			margin-top: 4px;
			padding-top: 4px;
		}
	}
</style>
